module.exports = __webpack_public_path__ + "img/procurement.7063353f.png";